// Pure month-string and comparison maths for the Receita report. UI-free so the SPA test setup can cover it.
// Months are YYYY-MM in Cabo Verde local time (UTC-1, no DST), matching the API.

export function currentMonthInCaboVerde(now: Date = new Date()): string {
  const shifted = new Date(now.getTime() - 60 * 60 * 1000);
  return `${shifted.getUTCFullYear()}-${String(shifted.getUTCMonth() + 1).padStart(2, '0')}`;
}

export function addMonths(ym: string, delta: number): string {
  const [y, m] = ym.split('-').map(Number);
  const base = new Date(Date.UTC(y, m - 1, 1));
  base.setUTCMonth(base.getUTCMonth() + delta);
  return `${base.getUTCFullYear()}-${String(base.getUTCMonth() + 1).padStart(2, '0')}`;
}

export type ChangeDirection = 'up' | 'down' | 'flat';

export interface Change {
  abs: number;
  /** null when the previous value is zero (no meaningful percentage — shown as "—"). */
  pct: number | null;
  direction: ChangeDirection;
}

export function change(current: number, previous: number): Change {
  const abs = current - previous;
  return {
    abs,
    pct: previous === 0 ? null : (abs / previous) * 100,
    direction: abs > 0 ? 'up' : abs < 0 ? 'down' : 'flat'
  };
}

// The percentage label for a change: "—" when there is no previous value (previous was zero), "0%" when it
// rounds to zero (never "+0%" or "-0%"), otherwise a signed integer percent.
export function formatPct(pct: number | null): string {
  if (pct === null) {
    return '—';
  }
  // Symmetric rounding: Math.round is asymmetric at .5 (rounds toward +∞), which would round -0.5% to 0 but
  // +0.5% to +1%. Round the magnitude and reapply the sign.
  const rounded = Math.sign(pct) * Math.round(Math.abs(pct));
  return rounded === 0 ? '0%' : `${rounded > 0 ? '+' : ''}${rounded}%`;
}
